import { LeftOutlined } from '@ant-design/icons';
import { Button, type ButtonProps } from '@arkestro/arkestro-design-system';
import { safeKeyPress } from 'utils/accessibility';

interface BackButtonProps extends ButtonProps {
  hideIcon?: boolean;
  onClick: () => void;
  style?: any;
}

export const BackButton = ({
  onClick,
  className,
  children,
  hideIcon,
  style,
}: BackButtonProps) => (
  <Button
    className={className}
    data-testid="back-button"
    onClick={onClick}
    onKeyPress={e => safeKeyPress(e, onClick)}
    style={style}
    tabIndex={0}
  >
    {!hideIcon && <LeftOutlined />}
    {children || 'Back'}
  </Button>
);
